import React, { createContext, useContext, ReactNode } from "react";
import { useMyLearning } from "@root/hooks/useMyLearning";

const defaultState: any = {};

const MyLearningContext = createContext<any>(defaultState);

interface MyLearningProviderProps {
  children: ReactNode;
}

export const MyLearningProvider: React.FC<MyLearningProviderProps> = ({
  children,
}) => {
  const data = useMyLearning();
  return (
    <MyLearningContext.Provider value={data}>
      {children}
    </MyLearningContext.Provider>
  );
};

export const useMyLearningContext = () => {
  return useContext(MyLearningContext);
};
